import Axios, { AxiosRequestConfig } from 'axios';
import {
  URL_BACKEND_ROOT
} from "../app/AppConst";
import AuthUtility from "../util/AuthUtility";
import { MenuGroupModel } from "../dto/MenuGroupModel";
import { MenuModel } from "../dto/MenuModel";
import MenuGroup from '../views/menu_group/MenuGroup';
import { MenuMatriceModel } from '../dto/MenuMatriceModel';
import { MenuItemModel } from '../dto/MenuItemModel';
import { MenuLayoutListModel } from '../dto/MenuLayoutList/MenuLayoutListModel';
import { CategoryModel } from '../dto/category/CategoryModel';
import { ApiClient } from '../util/ApiUtility';

export const onMenuGroupSubmit = async (data: MenuGroupModel) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/settings/menu-group/save',
    data
  }
  try {
    const {data: response} = await ApiClient().request(requestConfig);
    return response;
  } catch (e: any) {
    return {error: e.response.data.error_description}
  }
}

export const onMenuSubmit = async (data: MenuModel) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/settings/menu/save',
    data
  }
  try {
    const {data: response} = await ApiClient().request(requestConfig);
    return response;
  } catch (e: any) {
    return {error: e.response.data.error_description}
  }
}

export const onMenuGroupList = async () => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/settings/menu-group/list'
  }
  const response = await ApiClient().request<Array<MenuGroupModel>>(requestConfig);
  return response;
}

export const onMenuLayout = async () => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/settings/menu-layout'
  }
  const response = await ApiClient().request<Array<MenuLayoutListModel>>(requestConfig);
  
  if(response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Цэсний layout татахад алдаа гарлаа.");
  }
}

export const onMenuMatrices = async () => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/settings/menu-matrices'
  }
  const response = await ApiClient().request<MenuMatriceModel>(requestConfig);
  
  if(response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onUpdateMatrice = async (data: MenuItemModel) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/settings/update-matrices',
    data
  }
  const response = await ApiClient().request(requestConfig);
  
  if(response.status >= 200 && response.status < 300) {;
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}